import { render, staticRenderFns } from "./OabProcessos.vue?vue&type=template&id=5a33ff3c&scoped=true&"
import script from "./OabProcessos.vue?vue&type=script&lang=js&"
export * from "./OabProcessos.vue?vue&type=script&lang=js&"
import style0 from "./OabProcessos.vue?vue&type=style&index=0&id=5a33ff3c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33ff3c",
  null
  
)

export default component.exports